var _excluded = ["domRef", "inputRef", "tag", "prefix", "suffix", "clear", "children", "inputClassName", "inputStyle", "className", "type", "value", "defaultValue", "maxLength", "disabled", "disableSuffixAnimation", "onValueChange", "onClear", "onChange", "onFocus", "onBlur", "onKeyDown", "onKeyUp", "onKeyPress", "onClick", "onPressEnter", "onCopy", "onCompositionStart", "onCompositionUpdate", "onCompositionEnd", "readOnly", "htmlReadOnly", "fieldMark", "renderCount"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useCombineCallback, useCombineRef, useRefCallback } from '@okee-uikit/react-hooks';
import { isKorean, pick, isFunction } from '@okee-uikit/react-utils';
import { INPUT_COMMON_ATTRS, TEXTAREA_COMMON_ATTRS } from './const';
export function InputWrapper(props) {
  var _props$domRef = props.domRef,
      domRef = _props$domRef === void 0 ? null : _props$domRef,
      _props$inputRef = props.inputRef,
      inputRef = _props$inputRef === void 0 ? null : _props$inputRef,
      _props$tag = props.tag,
      tag = _props$tag === void 0 ? 'input' : _props$tag,
      prefix = props.prefix,
      suffix = props.suffix,
      clear = props.clear,
      children = props.children,
      inputClassName = props.inputClassName,
      inputStyle = props.inputStyle,
      className = props.className,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      value = props.value,
      defaultValue = props.defaultValue,
      maxLength = props.maxLength,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      disableSuffixAnimation = props.disableSuffixAnimation,
      onValueChange = props.onValueChange,
      onClear = props.onClear,
      onChange = props.onChange,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onKeyPress = props.onKeyPress,
      onClick = props.onClick,
      onPressEnter = props.onPressEnter,
      onCopy = props.onCopy,
      onCompositionStart = props.onCompositionStart,
      onCompositionUpdate = props.onCompositionUpdate,
      onCompositionEnd = props.onCompositionEnd,
      readOnly = props.readOnly,
      htmlReadOnly = props.htmlReadOnly,
      fieldMark = props.fieldMark,
      renderCount = props.renderCount,
      extra = _objectWithoutProperties(props, _excluded);

  var innerInputRef = useRef(null);
  var combinedInputRef = useCombineRef(innerInputRef, inputRef);
  var onChangeCallback = useRefCallback(onChange);
  var onValueChangeCallback = useRefCallback(onValueChange);
  var onClearCallback = useRefCallback(onClear);
  var handleKeyDown = useCombineCallback(onKeyDown, function (e) {
    return e.keyCode === 13 && onPressEnter && onPressEnter(e);
  });
  var handleClick = useRefCallback(onClick);
  var isOnComposition = useRef(false);

  var onComposition = function onComposition(e) {
    var text = e.currentTarget.value;
    var lastCharacter = text[text.length - 1] || '';
    isOnComposition.current = !isKorean(lastCharacter);
  };

  var handleCompositionStart = useCombineCallback(onCompositionStart, onComposition);
  var handleCompositionUpdate = useCombineCallback(onCompositionUpdate, onComposition);
  var controlled = fieldMark ? false : value !== undefined;

  var _useState = useState(value == null ? '' : value),
      _useState2 = _slicedToArray(_useState, 2),
      innerValue = _useState2[0],
      setInnerValue = _useState2[1];

  var computedValue = fieldMark ? innerValue : value;
  var valueRef = useRef(value);
  var handleChange = useCallback(function (e) {
    var v = e.target.value;
    setInnerValue(v);

    if (fieldMark && isOnComposition.current) {
      onChangeCallback(e);
    } else {
      onChangeCallback(e);
      if (fieldMark) valueRef.current = v;
      onValueChangeCallback(v);
    }
  }, [fieldMark, controlled]);
  var compositionEnd = useCallback(function (event) {
    isOnComposition.current = false;
    var inputValue = event.currentTarget.value;

    if (fieldMark) {
      valueRef.current = inputValue;
      onValueChangeCallback(inputValue);
    } else {
      if (tag === 'textarea' && maxLength != null && controlled && inputValue.length > maxLength) {
        var input = innerInputRef.current;

        if (input == null) {
          return;
        }

        var v = inputValue.substring(0, maxLength);
        input.value = v;
        var changeEvent = Object.create(event);
        changeEvent.target = input;
        changeEvent.currentTarget = input;
        onChangeCallback(changeEvent);
        input.value = inputValue;
        onValueChangeCallback(v);
      }
    }
  }, [fieldMark]);
  useEffect(function () {
    if (fieldMark && valueRef.current !== value) {
      valueRef.current = value;
      setInnerValue(value == null ? '' : value);
    }
  }, [fieldMark, value]);
  var handleCompositionEnd = useCombineCallback(onCompositionEnd, compositionEnd);
  var handleLabelClick = useCallback(function (e) {
    var _a;

    if (e.target !== combinedInputRef.current) {
      e.preventDefault();
      (_a = combinedInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
  }, []);
  var handleReset = useCallback(function (e) {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    var input = innerInputRef.current;

    if (input == null) {
      return;
    }

    isOnComposition.current = false;
    var originalInputValue = input.value;
    input.value = '';
    var event = Object.create(e);
    event.target = input;
    event.currentTarget = input;
    onChangeCallback(event);

    if (controlled) {
      input.value = originalInputValue;
    } else {
      setInnerValue('');
    }

    onValueChangeCallback('');
    onClearCallback();
  }, [controlled]);

  var _pick = pick(extra, tag === 'textarea' ? TEXTAREA_COMMON_ATTRS : INPUT_COMMON_ATTRS),
      _pick2 = _slicedToArray(_pick, 2),
      inputAttrs = _pick2[0],
      labelAttrs = _pick2[1];

  var renderSuffix = function renderSuffix() {
    var _a;

    var showClear = fieldMark || controlled ? computedValue : (_a = innerInputRef.current) === null || _a === void 0 ? void 0 : _a.value;

    if (React.isValidElement(clear) && showClear) {
      return React.cloneElement(clear, {
        onClick: handleReset,
        key: 'clear'
      });
    }

    var realSuffix = isFunction(suffix) ? suffix(controlled ? value : innerValue) : suffix || children;

    if (React.isValidElement(realSuffix)) {
      return React.cloneElement(realSuffix, {
        key: 'suffix'
      });
    }

    return realSuffix;
  };

  return React.createElement("label", _objectSpread(_objectSpread({}, labelAttrs), {}, {
    className: className,
    ref: domRef,
    onClick: handleLabelClick
  }), prefix, React.createElement(tag, _objectSpread(_objectSpread({}, inputAttrs), {}, {
    tabIndex: 0,
    type: type,
    className: inputClassName,
    style: inputStyle,
    disabled: disabled,
    value: computedValue,
    defaultValue: defaultValue,
    maxLength: maxLength,
    onCompositionStart: handleCompositionStart,
    onCompositionUpdate: handleCompositionUpdate,
    onCompositionEnd: handleCompositionEnd,
    onChange: handleChange,
    onKeyDown: handleKeyDown,
    onKeyUp: onKeyUp,
    onKeyPress: onKeyPress,
    onClick: handleClick,
    onFocus: onFocus,
    onBlur: onBlur,
    onCopy: onCopy,
    readOnly: htmlReadOnly !== null && htmlReadOnly !== void 0 ? htmlReadOnly : readOnly,
    ref: combinedInputRef
  })), renderSuffix(), renderCount === null || renderCount === void 0 ? void 0 : renderCount());
}